import { combineReducers } from "redux";
import {
  ROTATE_ELEMENT,
  CHOOSE_CLIPART,
  ADD_TEXT,
  UPDATE_TEXT_VALUE,
  DROP_ELEMENT,
  DROP_SELECTED_ELEMENTS,
  MOVE_LEFT,
  UPDATE_FONT,
  UPDATE_COLOR,
  UPDATE_DESIGN_NAME,
  UPDATE_FONT_SIZE,
  UPDATE_IMAGE_SIZE,
  UPDATE_LETTER_SPACING,
  UPDATE_TRANSFORM_AMOUNT,
  UPDATE_TRANSFORM_TYPE,
  ALIGN_LEFT,
  ALIGN_RIGHT,
  ALIGN_TOP,
  ALIGN_BOTTOM,
  ALIGN_HORIZONTAL,
  ALIGN_VERTICAL,
  CENTER_ALL,
  UPDATE_ANCHOR_POINT,
  REPOSITION_ANCHORED_ELEMENT,
  ALIGN_ITEMS_LEFT,
  ALIGN_ITEMS_CENTER,
  ALIGN_ITEMS_RIGHT,
  TOGGLE_MOBILE_DRAWER
} from "../actions";
import undoable from "redux-undo";
import reduceReducers from "reduce-reducers";
import activeToolCollection from "./ActiveToolCollectionReducer";
import fonts from "./FontsReducer";
import clipart from "./ClipartReducer";
import design from "./DesignReducer";
import designClipart from "./design/ClipartReducer";
import dropElement from "./design/DropElementReducer";
import dropSelectedElements from "./design/DropSelectedElementsReducer";
import isDragging from "./IsDraggingReducer";
import moveElements from "./design/MoveElementsReducer";
import text from "./design/TextReducer";
import dialog from "./DialogReducer";
import selectSingleElement from "./design/SelectSingleElementReducer";
import selectMultipleElements from "./design/SelectMultipleElementReducer";
import elementDimensions from "./design/ElementDimensionsReducer";
import userArtDimensions from "./design/UserArtDimensionsReducer";
import alignLeft from "./design/align/AlignLeftReducer";
import alignRight from "./design/align/AlignRightReducer";
import alignTop from "./design/align/AlignTopReducer";
import alignBottom from "./design/align/AlignBottomReducer";
import alignHorizontal from "./design/align/AlignHorizontalReducer";
import alignVertical from "./design/align/AlignVerticalReducer";
import alignItems from "./design/align/AlignItemsReducer";
import centerAll from "./design/CenterAllReducer";
import rotateElement from "./design/RotateElementReducer";
import sharing from "./ShareReducer";
import productOption from "./ProductOptionReducer";
import override from "./Override";
import zoomed from "./ZoomReducer";
import upload from "./UploadReducer";
import user from "./UserReducer";
import dirtyDesign from "./DirtyDesignReducer";
import bleed from "./BleedReducer";
import repositionDesign from "./design/RepositionDesignReducer";
import verifyElementsLoaded from "./VerifyElementsLoadedReducer";
import admin from "./AdminReducer";
import validateDesign from "./design/ValidateDesignElementsReducer";
import invalidDialog from "./InvalidDesignDialogReducer";
import pricebreaks from "./PricebreaksReducer";
import quantity from "./QuantityReducer";
import updateAnchorPoint from "./design/AnchorElementReducer";
import repositionAnchoredElement from "./design/RepositionAnchoredElementReducer";
import unifyText from "./UnifyTextReducer";
import currentColors from "./CurrentColorsReducer";
import deletingUserArt from "./DeleteUserArtReducer";
import copyFromDesignId from "./CopyFromDesignReducer";
import copyDesign from "./design/CopyDesignReducer";

function versionable(reducer) {
  var rawConfig =
    arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var config = {
    filter:
      rawConfig.filter ||
      function () {
        return true;
      }
  };

  return function (previous, current) {
    let nextState = reducer(previous, current);

    // we only want to track changes by specific actions
    if (config.filter && typeof config.filter === "function") {
      if (!config.filter(current, nextState, previous)) {
        return nextState;
      }
    }

    if (nextState !== previous) {
      nextState = {
        ...nextState,
        version: new Date().getTime()
      };
    }
    return nextState;
  };
}

let composedDesignReducer = reduceReducers(
  design,
  text,
  designClipart,
  dropElement,
  dropSelectedElements,
  moveElements,
  selectSingleElement,
  selectMultipleElements,
  elementDimensions,
  userArtDimensions,
  alignItems,
  centerAll,
  alignLeft,
  alignRight,
  alignTop,
  alignBottom,
  alignHorizontal,
  alignVertical,
  rotateElement,
  repositionDesign,
  validateDesign,
  updateAnchorPoint,
  repositionAnchoredElement,
  copyDesign
);
let versionedDesignReducer = versionable(composedDesignReducer, {
  filter: filterActions
});

function filterActions(action, currentState, previousState) {
  const toInclude = [
    ADD_TEXT,
    CHOOSE_CLIPART,
    DROP_ELEMENT,
    DROP_SELECTED_ELEMENTS,
    MOVE_LEFT,
    ROTATE_ELEMENT,
    UPDATE_COLOR,
    UPDATE_DESIGN_NAME,
    UPDATE_FONT,
    UPDATE_FONT_SIZE,
    UPDATE_IMAGE_SIZE,
    UPDATE_LETTER_SPACING,
    UPDATE_TEXT_VALUE,
    UPDATE_TRANSFORM_AMOUNT,
    UPDATE_TRANSFORM_TYPE,
    ALIGN_LEFT,
    ALIGN_RIGHT,
    ALIGN_TOP,
    ALIGN_BOTTOM,
    ALIGN_HORIZONTAL,
    ALIGN_VERTICAL,
    ALIGN_ITEMS_LEFT,
    ALIGN_ITEMS_CENTER,
    ALIGN_ITEMS_RIGHT,
    CENTER_ALL,
    UPDATE_ANCHOR_POINT,
    REPOSITION_ANCHORED_ELEMENT
  ];
  return toInclude.indexOf(action.type) !== -1;
}

// New Mobile Drawer Reducer
const mobileDrawerReducer = (state = { isOpen: false }, action) => {
  switch (action.type) {
    case TOGGLE_MOBILE_DRAWER:
      return {
        ...state,
        isOpen: action.payload.isOpen
      };
    default:
      return state;
  }
};

const reducers = {
  override,
  activeToolCollection,
  fonts,
  clipart,
  design: undoable(versionedDesignReducer, {
    limit: 20,
    filter: filterActions
  }),
  productOption,
  dialog,
  sharing,
  zoomed,
  upload,
  user,
  dirtyDesign,
  bleed,
  verifyElementsLoaded,
  isDragging,
  admin,
  invalidDialog,
  pricebreaks,
  quantity,
  unifyText,
  currentColors,
  deletingUserArt,
  copyFromDesignId,
  mobileDrawer: mobileDrawerReducer
};

const rootReducer = combineReducers(reducers);
export default rootReducer;
